module.exports = __webpack_public_path__ + "static/media/menu-icon-badge.8db8a477.png";